import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import ButtonBase from '@mui/material/ButtonBase';
import Select from '@mui/material/Select';
import Link from '@mui/material/Link';
import InputLabel from '@mui/material/InputLabel';
import { green } from '@mui/material/colors';
import Paper from "@mui/material/Paper";
import CircularProgress from '@mui/material/CircularProgress';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ScatterChart, XAxis, YAxis, Tooltip, Scatter, Legend, CartesianGrid } from 'recharts';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, query, addDoc, where } from 'firebase/firestore'
import { getStorage, ref, uploadBytes } from 'firebase/storage';

// Connect to current firebase project
const firebaseApp = initializeApp({
  apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
  authDomain: "ambient-systems.firebaseapp.com",
  databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ambient-systems",
  storageBucket: "ambient-systems.appspot.com",
  messagingSenderId: "1001740093061",
  appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
});
const firestore = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

/* Identify the current user */
const user_email = window.localStorage.getItem('user_email');

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

const drawerWidth = 220;


// Main function of this page
export default function GraphModelPage() {
  const theme = useTheme()
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);  
  
  const data01 = [
    { x: 10, y: 30., name: "g"  },
    { x: 20, y: 150, name: "e" },
    { x: 40, y: 130, name: "h" },
    { x: 60, y: 200, name: "b" },
    { x: 80, y: 370, name: "c" }
  ];
  const data02 = [
    { x: 20, y: 150, name: "e" },
    { x: 60, y: 200, name: "b" },
    {x: 100, y: 250, name: "a" },
    { x: 110, y: 400, name: "f" }
  ];
  const data03 = [
    { x: 60, y: 200, name: "b" },
    { x: 80, y: 150, name: "d" }
  ];
  const data04 = [
    {x: 10, y: 30, name: "g"},
    {x: 40, y: 130, name: "h"},
    {x: 80, y: 150, name: "d"},
    {x: 100, y: 250, name: "a"},
    {x: 80, y: 370, name: "c"},
    {x: 110, y: 400, name: "f"}
  ];
  const CustomizedLabel = ({
    x, y, name
  }) => {
    return (
      <text x={x} y={y} fill="green" textAnchor="end" dominantBaseline="central">
        {name}
      </text>
    );
  };

  return (
    <Box sx={{ display: "flex", height: "100%" }}>

      {/* Sub-Sidebar layout */}
      <Drawer variant="permanent" open={open} sx={{ height: 1000 }}>
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            px: [1],
            height: 66,
          }}
        >
          <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
            {open ? (
              <KeyboardDoubleArrowLeftIcon />
            ) : (
              <KeyboardDoubleArrowRightIcon />
            )}
          </IconButton>
        </Toolbar>

        <Divider />

        {/* Sub-bar Navigations */}
        <List component="nav">
          <ListItemButton>
            <ButtonBase href="/Dashboard/ML" fullWidth>
              <ListItemIcon>
                <AssignmentIcon />
              </ListItemIcon>
              <ListItemText primary="Relation Discovery" />
            </ButtonBase>
          </ListItemButton>

          <ListItemButton>
            <ButtonBase href="/Dashboard/ML/Recommendation" fullWidth>
              <ListItemIcon>
                <AssignmentIcon />
              </ListItemIcon>
              <ListItemText primary="Recommendation" />
            </ButtonBase>
          </ListItemButton>

          <ListItemButton>
            <ButtonBase href="/Dashboard/ML/GraphModel" fullWidth>
              <ListItemIcon>
                <AssignmentIcon />
              </ListItemIcon>
              <ListItemText primary="Graph Model" />
            </ButtonBase>
          </ListItemButton>
        </List>
      </Drawer>

      {/* Main space of page*/}
      <Box>
        {/* Title */}
        <Box sx={{ width: "100%" }}>
          <Typography
            component="h1"
            variant="subtitle1"
            color="inherit"
            noWrap
            sx={{ flexGrow: 1, mt: 3, ml: 8 }}
          >
            Ambient / Machine Learning / Graph Model
          </Typography>
          <Typography
            component="h1"
            variant="h4"
            color="inherit"
            noWrap
            sx={{ flexGrow: 1, ml: 8, mb: 2 }}
          >
            Graph Model
          </Typography>
        </Box>

        {/* Sub-function for demo, simple animation, contains table */}
        <ShowFiles />

        {/* Droplists */}
        <Box sx={{ mt: 1, ml: 8, mb: 2, display: "flex" }}>
          <FormControl sx={{ minWidth: 100 }} variant= "standard">
            <InputLabel htmlFor="source">Source</InputLabel>
            <Select native defaultValue="" id="source" disableUnderline
              theme={theme}
              sx={{
                  borderRadius: 25,
                  backgroundColor: theme.palette.background.default,
                  padding: "6px 15px",
              }}>
                <option value={"g"}>g</option>
                <option value={"f"}>f</option>
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 100, ml: 2 }} variant= "standard">
            <InputLabel htmlFor="destination">Destination</InputLabel>
            <Select native defaultValue="" id="destination" disableUnderline
              theme={theme}
              sx={{
                  borderRadius: 25,
                  backgroundColor: theme.palette.background.default,
                  padding: "6px 15px",
              }}>
                <option value={"f"}>f</option>
                <option value={"g"}>g</option>
            </Select>
          </FormControl>
        </Box>

        {/* Read button and hidden chart */}
        {/* <Box>
            <Button
                variant="contained"
                color="primary"
                sx={{ ml: 8, borderRadius: 5 }}
                position="absolute"
                onClick={handleButtonClick}
            >
                Read Data
            </Button>
            {show2 && 
            <Box sx={{ mt: 2, ml: 7 }}>
                <ScatterChart
                    width={500}
                    height={400}
                    margin={{
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20
                    }}
                >
                  <XAxis type="number" dataKey="x" name="x coordinate" />
                  <YAxis type="number" dataKey="y" name="y coordinate" />
                  <Tooltip cursor={{ strokeDasharray: "3 3" }} />
                  <Scatter
                      name=" "
                      data={data04}
                      fill="#8884d8"
                      shape="cross"
                      label={<CustomizedLabel />}
                  />
                  <Scatter
                      name=" "
                      data={data02}
                      fill="#82ca9d"
                      shape="diamond"
                      label={<CustomizedLabel />}
                  />
                  <Scatter
                      name=" "
                      data={data03}
                      fill="#82ca9d"
                      shape="diamond"
                      label={<CustomizedLabel />}
                  />
                  <Scatter
                      name=" "
                      data={data01}
                      fill="#82ca9d"
                      shape="diamond"
                      label={<CustomizedLabel />}
                  />
                </ScatterChart>
            </Box>
            }
        </Box> */}

        {/* Confirm button and hidden chart */}
        <Box>
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 3, ml: 8, borderRadius: 5 }}
              position="absolute"
              onClick={() => setShow(prev => !prev)}
            >
              Confirm
            </Button>
            {show && 
            <Box sx={{ mt: 3, ml: 8,}}>
              <Typography
                component="h1"
                variant="subtitle1"
                color="inherit"
                noWrap
                sx={{ flexGrow: 1 }}
              >
                Analysis results:
              </Typography>

                <ScatterChart
                    width={500}
                    height={400}
                    margin={{
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20
                    }}
                >
                    <CartesianGrid />
                    <XAxis type="number" dataKey="x" name="x coordinate" />
                    <YAxis type="number" dataKey="y" name="y coordinate" />
                    <Tooltip cursor={{ strokeDasharray: "3 3" }} />
                    <Legend />
                    <Scatter
                        name="min time cost path, cost=7"
                        data={data04}
                        fill="#8884d8"
                        line
                        shape="cross"
                        label={<CustomizedLabel />}
                    />
                    <Scatter
                        name=" "
                        data={data02}
                        fill="#82ca9d"
                        line
                        shape="diamond"
                        label={<CustomizedLabel />}
                    />
                    <Scatter
                        name=" "
                        data={data03}
                        fill="#82ca9d"
                        line
                        shape="diamond"
                        label={<CustomizedLabel />}
                    />
                    <Scatter
                        name=" "
                        data={data01}
                        fill="#82ca9d"
                        line
                        shape="diamond"
                        label={<CustomizedLabel />}
                    />
                    
                </ScatterChart>

              {/* Navigation button */}
              <Box sx={{ minHeight: 50 }}>
                <Link href="/Dashboard/Output/GraphModel" underline="hover">
                  {'See Final Solutions'}
                </Link>
              </Box>
            </Box>
            }
        </Box>
      </Box>
    </Box>
  );
}

function ShowFiles() {
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const timer = React.useRef();

  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  };

  React.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const [flag, setFlag] = React.useState();

  React.useEffect(() => {
    const modelQuery = query(
      collection(firestore, 'models'),
      where('user_email', '==', user_email),
      where('name', '==', 'Graph Model'),
    );
    onSnapshot(modelQuery, snapshot => {
        const t = (snapshot.docs.map(doc => ({ id: doc.id, data: doc.data() })))
        if (!t[0]) {
            setFlag(true)
        } else {
            setFlag(false)
        }
    })
  }, []);

  /* Show data and meanwhile add data to database */
  const handleButtonClick = () => {
    if (!loading) {
      setSuccess(false);
      setData();
      setHeader();
      setLoading(true);
      timer.current = window.setTimeout(() => {
        setSuccess(true);
        setLoading(false);
        setData(tmpdata);
        setHeader(tmpheader);
      }, 2000);

      // if(flag) {
      //   const CollectionRef = collection(firestore, 'models')
      //   const name = "Graph Model"
      //   addDoc(CollectionRef, {name, user_email})
      //         .then(response => {
      //         console.log(response.id)
      //         })
      //         .catch(error => {
      //         console.log(error.message)
      //         })
      // }
    }
  };

  const [tmpheader, setTmpheader] = useState([])
  const [header, setHeader] = useState([])
  const [tmpdata, setTmpdata] = useState([])
  const [data, setData] = useState([])

  /* Storage upload functions */
  const onFileChange = (e) => {
    const file = e.target.files[0]
    const reader = new FileReader()

      reader.onload = function (e) {
        const text = e.target.result;
        const Data = csvToArray(text);
        setTmpdata(Data)
      };

      reader.readAsText(file)

    const userRef = ref(storage, user_email+'/Graph Model/'+file.name)
    uploadBytes(userRef, file).then((snapshot) => {
      console.log("Uploaded file!")
      alert("Upload successfully!")
    })
  }

  function csvToArray(str, delimiter = ",") {
    const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
    if (headers.length > 10) {
      const res = headers.slice(0, 10)
      setTmpheader(res)
    } else {
      setTmpheader(headers)
    }
    const rows = str.slice(str.indexOf("\n") + 1).split("\n");
    const arr = rows.map(function (row) {
      const values = row.split(delimiter);
      const el = headers.reduce(function (object, header, index) {
        object[header] = values[index];
        return object;
      }, {});
      return el;
    });

    if (arr.length > 10) {
      return arr.slice(0, 10)
    } else {
      return arr
    }
    return 
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ position: 'relative' }}>
        <Button variant="contained" color='primary' component="label" sx={{ ml: 8 }}>
            upload data
            <input
                type="file"
                accept=".csv"
                hidden
                onChange={onFileChange}
            />
        </Button>

        <Button
          variant="contained"
          sx={buttonSx, { ml: 3 }}
          disabled={loading}
          onClick={handleButtonClick}
        >
          Read Data
        </Button>
        {loading && (
          <CircularProgress
            size={24}
            sx={{
              color: green[500],
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px',
              marginLeft: '-12px',
            }}
          />
        )}

        {/* Hidden table */}
        <Box>
          <TableContainer component={Paper} sx={{ mt: 2, ml: 8 }}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  {header?.map((column) => (
                    <TableCell align="right">{column}</TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {data?.map((row) => (
                  <TableRow
                    key={Object.values(row)[0]}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {Object.values(row)[0]}
                    </TableCell>
                    <TableCell align="right">{Object.values(row)[1]}</TableCell>
                    <TableCell align="right">{Object.values(row)[2]}</TableCell>
                    <TableCell align="right">{Object.values(row)[3]}</TableCell>
                    <TableCell align="right">{Object.values(row)[4]}</TableCell>
                    <TableCell align="right">{Object.values(row)[5]}</TableCell>
                    <TableCell align="right">{Object.values(row)[6]}</TableCell>
                    <TableCell align="right">{Object.values(row)[7]}</TableCell>
                    <TableCell align="right">{Object.values(row)[8]}</TableCell>
                    <TableCell align="right">{Object.values(row)[9]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Box>
  );
}
